var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.5 72.53",
    id: "file",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b76a8a",
    d: "M61.5 67.53a5 5 0 0 1-5 5h-40a5 5 0 0 1-5-5v-51a5 5 0 0 1 5-5h16.85A13.91 13.91 0 0 1 41.88 15L58 31.11a13.91 13.91 0 0 1 3.54 8.54z",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6a80b9",
    d: "M47.5 66h-40A7.51 7.51 0 0 1 0 58.53V7.5A7.51 7.51 0 0 1 7.5 0h16.85a16.23 16.23 0 0 1 10.3 4.27l16.08 16.08A16.24 16.24 0 0 1 55 30.65v27.88A7.51 7.51 0 0 1 47.5 66zM5 5v56h45V30.65a11.57 11.57 0 0 0-2.8-6.77L31.12 7.8A11.56 11.56 0 0 0 24.35 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6a80b9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.5 25.65H29.35V2.5M39.59 35.92H15.41M39.59 43.77H15.41M39.59 51.63H15.41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.6fc65ff7116af51405709c229e622aa5.svg";
export { ForwardRef as ReactComponent };